import { z } from 'zod';
export const projectKindSchema = z.object({
    id: z.number().min(1),
    name: z.string()
});
//# sourceMappingURL=projectKind.model.js.map